import localForage from 'localforage';
import { initSliders } from '../components/dc-slider.js';
import { initGiftGuide } from '../components/giftGuide';
import HomepageModule from '../components/react/HomepageModule';
import initEligibilityCheck from '../components/react/UserEligibilityCheck';
import initComparePage from './comparePage.js';
import PCWorldClosureAnalyticsInit from '../analyticsPCWRedirection';

const UISettings = require('../utils/UISettings');
const globalInit = require('./global.js').initPage;

const othersInit = {
  DOMReadyInit: function DOMReadyInit() {
    initSliders();
    initGiftGuide();
    initHomepage();
    initEligibilityCheck();
    initComparePage();
    PCWorldClosureAnalyticsInit();
  },
  init: function init() {

  }
};

function initHomepageModule(groupcallIsLoading) {
  if (!groupcallIsLoading) {
    setTimeout(() => {
      const userDetails = window.App.settings.get('userDetails');

      if (!window.App.settings.get('isHomepageModuleEnabled')) {
        return;
      }

      if (userDetails && userDetails.email) {
        HomepageModule.init(undefined, userDetails.email, userDetails.isGuest);
      } else {
        localForage.getItem('basket')
          .then((basketData) => {
            if (basketData && basketData.customer) {
              HomepageModule.init(
                basketData.customer.id,
                basketData.customer.email,
                basketData.customer.isGuest
              );
            }
          });
      }
    }, 100);
  }
}

function initHomepage() {
  UISettings.watchChanges('groupcallIsLoading', UISettings.Type.USER, initHomepageModule);
  initHomepageModule(UISettings.get('groupcallIsLoading', UISettings.Type.USER));
}

globalInit(othersInit);
